import React from 'react';
import { listsViewStyles } from '../styles';
import { FormControl, Grid, TextField, Typography, withStyles } from '@material-ui/core';

function CalendarTab({ classes, register, formValues, setFormValues }) {
    return (
        <Grid container direction="row" spacing={4}>
            <Grid item xs={12}>
                <Typography style={{ fontSize: 16 }}>
                    Add each list item in the textbox with each item on Its own line. Put them in the order you wish
                    them to appear.
                </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                <Typography style={{ fontSize: 16, marginBottom: 8 }}>Block names</Typography>
                <FormControl class={classes.textBox}>
                    <TextField
                        multiline
                        rows={8}
                        name="calendar_block_names"
                        id="calendar_block_names"
                        value={formValues.calendar_block_names}
                        inputRef={register()}
                        onChange={({ target }) => {
                            setFormValues({
                                ...formValues,
                                calendar_block_names: target.value
                            });
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
                <Typography style={{ fontSize: 16, marginBottom: 8 }}>Break names</Typography>
                <FormControl class={classes.textBox}>
                    <TextField
                        multiline
                        rows={8}
                        name="calendar_break_names"
                        id="calendar_break_names"
                        value={formValues.calendar_break_names}
                        inputRef={register()}
                        onChange={({ target }) => {
                            setFormValues({
                                ...formValues,
                                calendar_break_names: target.value
                            });
                        }}
                    />
                </FormControl>
            </Grid>
        </Grid>
    );
}

export default withStyles(listsViewStyles)(CalendarTab);
